/**
 * @file Module to create Menu component.
 */

/**
 * Class representing a menu.
 */
export class Menu {

  /**
   * Setup properties.
   * @param {HTMLElement} element - The DOM element to append the component.
   */
  constructor(element) {
    this.dom = {
      menu: element,
      items: element.querySelectorAll('.item')
    };
  }

  /**
   * Create component.
   * @public
   */
  init() {
  }

  /**
   * Toggle menu.
   * @public
   */
  toggle() {
    if (this.dom.menu.classList.contains('visible')) {
      this.hide();
    } else {
      this.show();
    }
  }

  /**
   * Show menu.
   * @public
   */
  show() {
    const parentClass = this.dom.menu.parentElement.classList;

    if (parentClass.contains('dropdown')) {
      parentClass.add('open');
    }

    this.dom.menu.classList.add('visible');
  }

  /**
   * Hide menu.
   * @public
   */
  hide() {
    const parentClass = this.dom.menu.parentElement.classList;

    if (parentClass.contains('dropdown')) {
      parentClass.remove('open');
    }

    this.dom.menu.classList.remove('visible');
  }
}
